angular.module('unergie.main')
.controller('potUseModalCtrl', ($scope, $uibModalInstance, ApiUser, DataAccess, BoFeaturesService, MS, AlertManager, ErrorCatcher, account) => {
    $scope.canUsePot = BoFeaturesService.isFeatureOn('usePot')
    $scope.fetchingCompletePotBalance = true
    $scope.amountLeft = 0

    $scope.useForContract = false
    $scope.useForInvestment = false
    $scope.useForDonation = false

    $scope.donationBeneficiaries = ['ATD', 'ESF']
    $scope.investmentBeneficiaries = ['AKUOCOOP']

    $scope.payload = {
        investment: {
            amount: 0,
        },
        donation: {
            amount: 0,
        },
        burn: {
            amount: 0,
        },
    }

    $scope.computeAmountLeft = () => {
        $scope.amountLeft = MS.round($scope.completePotBalance.forecast -
            (($scope.payload.investment.amount || 0) + ($scope.payload.donation.amount || 0) + ($scope.payload.burn.amount || 0)), 2)
    }

    $scope.maxBurnAmount = () => {
        $scope.payload.burn.amount = MS.round($scope.completePotBalance.forecast -
            (($scope.payload.investment.amount || 0) + ($scope.payload.donation.amount || 0)), 2)
        $scope.computeAmountLeft()
    }

    $scope.maxInvestmentAmount = () => {
        $scope.payload.investment.amount = MS.round($scope.completePotBalance.forecast -
            (($scope.payload.burn.amount || 0) + ($scope.payload.donation.amount || 0)), 2)
        $scope.computeAmountLeft()
    }

    $scope.maxDonationAmount = () => {
        $scope.payload.donation.amount = MS.round($scope.completePotBalance.forecast -
            (($scope.payload.burn.amount || 0) + ($scope.payload.investment.amount || 0)), 2)
        $scope.computeAmountLeft()
    }

    $scope.changeBurnAmount = () => {
        $scope.computeAmountLeft()
        if ($scope.amountLeft < 0) {
            $scope.maxBurnAmount()
        }
    }

    $scope.changeInvestmentAmount = () => {
        $scope.computeAmountLeft()
        if ($scope.amountLeft < 0) {
            $scope.maxInvestmentAmount()
        }
    }

    $scope.changeDonationAmount = () => {
        $scope.computeAmountLeft()
        if ($scope.amountLeft < 0) {
            $scope.maxDonationAmount()
        }
    }

    ApiUser.completePotBalance({ id_account: account.id }).$promise
    .then((completePotBalance) => {
        $scope.completePotBalance = completePotBalance
        const usedContract = _.map(completePotBalance.nextBurns, 'id_contract')
        $scope.contractIds = _.map(_.filter(account.contractList, (c) => c.status === 2 && !usedContract.includes(c.id)), 'id')
        $scope.amountLeft = completePotBalance.forecast
    })
    .catch(ErrorCatcher)
    .finally(() => {
        $scope.fetchingCompletePotBalance = false
    })

    $scope.changeContractUsage = () => {
        if (!$scope.useForContract) {
            $scope.payload.burn.amount = 0
            delete $scope.payload.burn.id_contract
            $scope.computeAmountLeft()
        }
    }

    $scope.changeInvestmentUsage = () => {
        if (!$scope.useForInvestment) {
            $scope.payload.investment.amount = 0
            delete $scope.payload.investment.beneficiary
            $scope.computeAmountLeft()
        }
    }

    $scope.changeDonationUsage = () => {
        if (!$scope.useForDonation) {
            $scope.payload.donation.amount = 0
            delete $scope.payload.donation.beneficiary
            $scope.computeAmountLeft()
        }
    }

    $scope.canUse = () => {
        return $scope.completePotBalance
            && $scope.amountLeft >= 0
            && $scope.amountLeft !== $scope.completePotBalance.forecast
            && (!$scope.useForContract || ($scope.payload.burn.id_contract && $scope.payload.burn.amount > 0))
            && (!$scope.useForInvestment || ($scope.payload.investment.beneficiary && $scope.payload.investment.amount > 0))
            && (!$scope.useForDonation || ($scope.payload.donation.beneficiary && $scope.payload.donation.amount > 0))
    }

    $scope.usePot = () => {
        $scope.using = true
        if (!$scope.useForContract) {
            delete $scope.payload.burn
        }
        if (!$scope.useForInvestment) {
            delete $scope.payload.investment
        }
        if (!$scope.useForDonation) {
            delete $scope.payload.donation
        }
        return DataAccess.multiPotInvestment({ id_account: account.id }, $scope.payload).$promise
        .then((completePotBalance) => {
            AlertManager.success(`Utilisation(s) enregistrée(s)`)
            $uibModalInstance.close(true)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.using = false
        })
    }

    $scope.close = $uibModalInstance.dismiss
})
